import { render, staticRenderFns } from "./LockScreenSettingsModal.vue?vue&type=template&id=9b36109e&scoped=true"
import script from "./LockScreenSettingsModal.vue?vue&type=script&lang=ts"
export * from "./LockScreenSettingsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b36109e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b36109e')) {
      api.createRecord('9b36109e', component.options)
    } else {
      api.reload('9b36109e', component.options)
    }
    module.hot.accept("./LockScreenSettingsModal.vue?vue&type=template&id=9b36109e&scoped=true", function () {
      api.rerender('9b36109e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/LockScreenSettingsModal.vue"
export default component.exports